export const COMMON_CATEGORIES = [
    'AGENT_PENSION_FUND_CONTRIBUTION_OVERDUE_LIST',
    'AGENT_MEDICAL_INSURANCE_OVERDUE_LIST',
    'ALL_CUSTOMS_FINE_TAX_OTHER_OVERDUE_LIST',
    'ALL_SOCIAL_TAX_OVERDUE_LIST',
    'AGENT_TAX_OVERDUE_LIST',
];

export const UNCOMMON_CATEGORIES = [
    'ABSENT_ADDRESS_AGENT_DATA_LIST',
    'PSEUDO_ENTERPRISE_LIST',
    'BANKRUPT_LIST',
    'INACTIVE_LIST',
    'REGISTRATION_INVALID_LIST',
    'REREGISTRATION_INVALID_LIST',
];

export const COMMON_CATEGORIES_TITLES = [
    {
        type: 'AGENT_PENSION_FUND_CONTRIBUTION_OVERDUE_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, имеющих задолженность ОПВ, ОППВ',
        ru: 'Основания для включения НП в Список налогоплательщиков, имеющих задолженность ОПВ, ОППВ',
        en: '',
        qq: '',
    },
    {
        type: 'AGENT_TAX_OVERDUE_LIST',
        kz: 'Основания для включения НП в Список ЮЛ, имеющих задолженность более 150 МРП (20.10.2022)',
        ru: 'Основания для включения НП в Список ЮЛ, имеющих задолженность более 150 МРП (20.10.2022)',
        en: '',
        qq: '',
    },
    {
        type: 'AGENT_MEDICAL_INSURANCE_OVERDUE_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, имеющих задолженность по ОСМС',
        ru: 'Основания для включения НП в Список налогоплательщиков, имеющих задолженность по ОСМС',
        en: '',
        qq: '',
    },
    {
        type: 'IP_LZCHP_TAX_OVERDUE_LIST',
        kz: 'Основания для включения НП в Список ИП, имеющих задолженность более 10 МРП (20.10.2022)',
        ru: 'Основания для включения НП в Список ИП, имеющих задолженность более 10 МРП (20.10.2022)',
        en: '',
        qq: '',
    },
    {
        type: 'ALL_CUSTOMS_FINE_TAX_OTHER_OVERDUE_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, имеющих  задолженность по таможенным платежам, налогам, специальным, антидемпинговым, компенсационным пошлинам, пеней, процентов',
        ru: 'Основания для включения НП в Список налогоплательщиков, имеющих  задолженность по таможенным платежам, налогам, специальным, антидемпинговым, компенсационным пошлинам, пеней, процентов',
        en: '',
        qq: '',
    },
    {
        type: 'ALL_SOCIAL_TAX_OVERDUE_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, имеющих задолженность по социальным отчислениям ',
        ru: 'Основания для включения НП в Список налогоплательщиков, имеющих задолженность по социальным отчислениям ',
        en: '',
        qq: '',
    },
    {
        type: 'ABSENT_ADDRESS_AGENT_DATA_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, отсутствующих по юридическому адресу',
        ru: 'Основания для включения НП в Список налогоплательщиков, отсутствующих по юридическому адресу',
        en: '',
        qq: '',
    },
];

export const UNCOMMON_CATEGORIES_TITLES = [
    {
        type: 'ABSENT_ADDRESS_AGENT_DATA_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, отсутствующих по юридическому адресу',
        ru: 'Основания для включения НП в Список налогоплательщиков, отсутствующих по юридическому адресу',
        en: 'Основания для включения НП в Список налогоплательщиков, отсутствующих по юридическому адресу',
        qq: '',
    },
    {
        type: 'PSEUDO_ENTERPRISE_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, признанных лжепредприятиями',
        ru: 'Основания для включения НП в Список налогоплательщиков, признанных лжепредприятиями',
        en: 'Основания для включения НП в Список налогоплательщиков, признанных лжепредприятиями',
        qq: 'Основания для включения НП в Список налогоплательщиков, признанных лжепредприятиями',
        actNumber: 'Решение суда',
        actCreateDate: 'Дата начала преступной деятельности',
    },
    {
        type: 'BANKRUPT_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, признанных банкротами',
        ru: 'Основания для включения НП в Список налогоплательщиков, признанных банкротами',
        en: 'Основания для включения НП в Список налогоплательщиков, признанных банкротами',
        qq: 'Основания для включения НП в Список налогоплательщиков, признанных банкротами',
        actNumber: 'Номер решения суда',
        actCreateDate: 'Дата решения суда',
    },
    {
        type: 'INACTIVE_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, признанных бездействующими',
        ru: 'Основания для включения НП в Список налогоплательщиков, признанных бездействующими',
        en: 'Основания для включения НП в Список налогоплательщиков, признанных бездействующими',
        qq: 'Основания для включения НП в Список налогоплательщиков, признанных бездействующими',
        actNumber: 'Номер приказа',
        actCreateDate: 'Дата приказа',
    },
    {
        type: 'REGISTRATION_INVALID_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, регистрация которых признана недействительной',
        ru: 'Основания для включения НП в Список налогоплательщиков, регистрация которых признана недействительной',
        en: 'Основания для включения НП в Список налогоплательщиков, регистрация которых признана недействительной',
        qq: 'Основания для включения НП в Список налогоплательщиков, регистрация которых признана недействительной',
        actNumber: 'Номер решения суда',
        actCreateDate: 'Дата решения суда',
    },
    {
        type: 'REREGISTRATION_INVALID_LIST',
        kz: 'Основания для включения НП в Список налогоплательщиков, перерегистрация которых признана недействительной',
        ru: 'Основания для включения НП в Список налогоплательщиков, перерегистрация которых признана недействительной',
        en: 'Основания для включения НП в Список налогоплательщиков, перерегистрация которых признана недействительной',
        qq: 'Основания для включения НП в Список налогоплательщиков, перерегистрация которых признана недействительной',
        actNumber: 'Номер решения суда',
        actCreateDate: 'Дата признания перерегистрации недействительной',
    },
];

export const LIST_UNRELIABLE_CATEGORIES_NAMES = [
    {
        id: 'AGENT_TAX_OVERDUE_LIST',
        ru: 'Информация о налогоплательщиках - юридических лицах, их структурных подразделениях, имеющих налоговую задолженность более 150 МРП, не погашенную в течение 4 месяцев со дня ее возникновения',
        kz: '150 АЕК-тен астам салық берешегі бар, олар пайда болған күннен бастап 4 ай ішінде өтемеген салық төлеушілер – заңды тұлғалар, олардың құрылымдық бөлімшелері туралы мәліметтер',
        en: 'Information about taxpayers - legal entities, their structural subdivisions, having a tax debt of more than 150 MCI, not repaid within 4 months from the date of its occurrence',
        qq: '150 AEK-ten astam salyq bereshegi bar, olar paıda bolǵan kúnnen bastap 4 aı ishinde ótemegen salyq tóleýshiler – zańdy tulǵalar, olardyń qurylymdyq bólimsheleri týraly málimetter',
    },
    {
        id: 'AGENT_PENSION_FUND_CONTRIBUTION_OVERDUE_LIST',
        ru: 'Список агентов, имеющих задолженность по обязательным пенсионным взносам, обязательным профессиональным пенсионным взносом, не погашенную в срок более шести месяцев со дня ее возникновения',
        kz: 'Міндетті зейнетақы жарналары, міндетті кәсіптік зейнетақы жарналары бойынша олар пайда болған күннен бастап алты айдан астам мерзімде өтелмеген берешегі бар агенттердің тізімі',
        en: 'List of agents who have arrears on mandatory pension contributions, mandatory professional pension contributions, not repaid within more than six months from the date of its occurrence',
        qq: 'Mindetti zeınetaqy jarnalary, mindetti kásiptik zeınetaqy jarnalary boıynsha olar paıda bolǵan kúnnen bastap alty aıdan astam merzimde ótelmegen bereshegi bar agentterdiń tizimi',
    },
    {
        id: 'AGENT_MEDICAL_INSURANCE_OVERDUE_LIST',
        ru: 'Список плательщиков имеющих задолженность по отчислениям и (или) взносам в фонд социального медицинского страхования, не погашенную в срок более шести месяцев со дня ее возникновения',
        kz: 'Әлеуметтік медициналық сақтандыру қорына аударымдар және (немесе) жарналар бойынша берешегі пайда болған күннен бастап алты айдан астам мерзімде өтелмеген төлеушілердің тізімі',
        en: 'The list of payers who have arrears on deductions and (or) contributions to the social health insurance fund that have not been repaid within more than six months from the date of its occurrence',
        qq: 'Áleýmettik medısınalyq saqtandyrý qoryna aýdarymdar jáne (nemese) jarnalar boıynsha bereshegi paıda bolǵan kúnnen bastap alty aıdan astam merzimde ótelmegen tóleýshilerdiń tizimi',
    },
    {
        id: 'IP_LZCHP_TAX_OVERDUE_LIST',
        ru: 'Информация о налогоплательщиках - индивидуальных предпринимателях, лицах, занимающихся частной практикой имеющих налоговую задолженность более 10 МРП, не погашенную в течение 4 месяцев со дня ее возникновения',
        kz: '10 АЕК-тен астам салық берешегі бар, олар пайда болған күннен бастап 4 ай ішінде өтемеген салық төлеушілер – дара кәсіпкерлер, жеке практикамен айналысатын тұлғалар туралы мәліметтер',
        en: 'Information about taxpayers - individual entrepreneurs, persons engaged in private practice who have a tax debt of more than 10 MCI, not repaid within 4 months from the date of its occurrence',
        qq: '10 AEK-ten astam salyq bereshegi bar, olar paıda bolǵan kúnnen bastap 4 aı ishinde ótemegen salyq tóleýshiler – dara kásipkerler, jeke praktıkamen aınalysatyn tulǵalar týraly málimetter',
    },
    {
        id: 'ALL_CUSTOMS_FINE_TAX_OTHER_OVERDUE_LIST',
        ru: 'Информация о плательщиках, имеющих задолженность по таможенным платежам, налогам, специальным, антидемпинговым, компенсационным пошлинам, пеней, процентов, не погашенную в течение 4-х месяцев со дня ее возникновения',
        kz: 'Кедендік төлемдер, салықтар, арнайы, демпингке қарсы, өтемақы баждары, өсімпұлдар, пайыздар бойынша, олар пайда болған күннен бастап 4 ай ішінде өтелмеген берешегі бар төлеушілер туралы ақпарат',
        en: 'Information about payers who have arrears on customs payments, taxes, special, anti-dumping, countervailing duties, penalties, interest, not repaid within 4 months from the date of its occurrence',
        qq: 'Kedendik tólemder, salyqtar, arnaıy, dempıńke qarsy, ótemaqy bajdary, ósimpuldar, paıyzdar boıynsha, olar paıda bolǵan kúnnen bastap 4 aı ishinde ótelmegen bereshegi bar tóleýshiler týraly aqparat',
    },
    {
        id: 'ALL_SOCIAL_TAX_OVERDUE_LIST',
        ru: 'Список плательщиков имеющих задолженность по социальным отчислениям, не погашенную в срок более шести месяцев со дня ее возникновения',
        kz: 'Әлеуметтік аударымдар бойынша берешегі пайда болған күннен бастап алты айдан астам мерзімде өтемеген төлеушілердің тізімі',
        en: 'The list of payers with arrears of social contributions, outstanding for more than six months from the date of its occurrence',
        qq: 'Áleýmettik aýdarymdar boıynsha bereshegi paıda bolǵan kúnnen bastap alty aıdan astam merzimde ótemegen tóleýshilerdiń tizimi',
    },
    {
        id: 'ABSENT_ADDRESS_AGENT_DATA_LIST',
        kz: 'Заңды мекенжайында жоқ салық төлеушілердің тізімі',
        ru: 'Список налогоплательщиков, отсутствующих по юридическому адресу',
        en: 'List of taxpayers who are absent at the legal address',
        qq: 'Zańdy mekenjaıynda joq salyq tóleýshilerdiń tizimi',
    },
    {
        id: 'PSEUDO_ENTERPRISE',
        ru: 'Список налогоплательщиков, признанных лжепредприятиями',
    },
    {
        id: 'REORGANIZED_IN_VIOLATION',
        ru: 'Список налогоплательщиков, реорганизованных с нарушением норм налогового кодекса',
    },
    {
        id: 'BANKRUPT',
        ru: 'Список налогоплательщиков, признанных банкротом',
    },
    {
        id: 'INACTIVE',
        ru: 'Список бездействующих налогоплательщиков',
    },
    {
        id: 'REGISTRATION_INVALID',
        ru: 'Список налогоплательщиков, регистрация которых признана недействительной',
    },
    {
        id: 'REREGISTRATION_INVALID',
        ru: 'Список налогоплательщиков, перерегистрация которых признана недействительной',
    },
    {
        id: 'WITH_TAX_ARREARS',
        ru: 'Список налогоплательщиков, имеющих налоговую задолженность',
    },
    {
        id: 'PSEUDO_ENTERPRISE_LIST',
        ru: 'Список налогоплательщиков, признанных лжепредприятиями',
    },
    {
        id: 'BANKRUPT_LIST',
        ru: 'Список налогоплательщиков, признанных банкротами',
    },
    {
        id: 'INACTIVE_LIST',
        ru: 'Список налогоплательщиков, признанных бездействующими',
    },
    {
        id: 'REGISTRATION_INVALID_LIST',
        ru: 'Список налогоплательщиков, регистрация которых признана недействительной',
    },
    {
        id: 'REREGISTRATION_INVALID_LIST',
        ru: 'Список налогоплательщиков, перерегистрация которых признана недействительной',
    },
];
